import type { ReactNode } from "react";

// WHY [BOL-CONFIRM-LINK-LIVE-WORKSPACE-001]: an email hash arriving in an
// authenticated tab may open a confirmation dialog, but it cannot remount the
// mounted business workspace (Chat/Voice, drafts, selected history). The
// workspace remains the first child across dialog open/close; its caller
// retains the same account/workspace key.
export function PreservedWorkspace({ workspace, confirmation }: {
  workspace: ReactNode;
  confirmation: ReactNode;
}) {
  return <>{workspace}{confirmation}</>;
}
